import React from 'react';

export default function MobileScrollUp({ active, goTo }) {
  return (
    <button
      className={`mobile-up${active === 0 ? ' mobile-up--hidden' : ''}`}
      onClick={() => goTo(0)}
      aria-label="Remonter en haut"
    >
      ↑
    </button>
  );
}
